import { render } from "./DettaglioContatto.vue?vue&type=template&id=793c27e0&ts=true"
import script from "./DettaglioContatto.vue?vue&type=script&lang=ts"
export * from "./DettaglioContatto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__